module.exports = __webpack_public_path__ + "fonts/STREN___.53fee205.TTF";